//
//  This middleware handle logic / server call when some json data from store is expired
//
import _ from 'lodash';

import {
    FAILURE_ACCOUNT_GAINS,
    RECEIVE_ACCOUNT_GAINS,
    REQUEST_ACCOUNT_GAINS
} from '../services/account/gains/constants';

import { fetchAccountGains } from '../services/account/gains/actions';

import { nowTimestamp } from '../utils/dateUtils';

export const refreshExpiredData = ({ dispatch, getState }) => next => action => {
    let fetching = getState().account.gains.fetching;
    let isAccountGainAction = [
        RECEIVE_ACCOUNT_GAINS,
        REQUEST_ACCOUNT_GAINS,
        FAILURE_ACCOUNT_GAINS
    ].includes(action.type);

    if (fetching || _.startsWith(action.type, '@@redux-form') || isAccountGainAction) {
        return next(action);
    }

    let authenticated = getState().authentication.isAuthenticated;

    if (authenticated) {
        let isExpired = getState().account.gains.expireAt <= nowTimestamp();
        if (isExpired) {
            dispatch(fetchAccountGains());
        }
    }

    return next(action);
};

export default refreshExpiredData;



// WEBPACK FOOTER //
// ./src/middlewares/refresheable.js